import type {ReactElement} from 'react';
import React from 'react';
import {TranscriptContextualMenuSubPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/transcript-customize-styles-panel/transcript-customize-styles-panel.types';
import {TranscriptSentenceTextColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/transcript-sentence-text-color-panel/transcript-sentence-text-color-panel';
import {TranscriptBackgroundColorPanel} from '@Components/poster-editor/components/transcript-background-color-panel/transcript-background-color-panel';
import {TranscriptActiveWordTextColorPanel} from '@Components/poster-editor/components/transcript-active-word-text-color-panel/transcript-active-word-text-color-panel';
import {TranscriptSentenceOutlineColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/transcript-sentence-outline-color-panel/transcript-sentence-outline-color-panel';
import {TranscriptActiveWordOutlineColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/transcript-active-word-outline-color-panel/transcript-active-word-outline-color-panel';
import {TranscriptShadowPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/transcript-shadow-panel/transcript-shadow-panel';
import {TranscriptItemFontSelector} from '@Components/poster-editor/components/poster-editing-side-panel/components/transcript-item-font-selector/transcript-item-font-selector';
import type {TranscriptCustomizeSubpanelContentProps} from './transcript-customize-subpanel-content.types';

export function TranscriptCustomizeSubpanelContent({...props}: TranscriptCustomizeSubpanelContentProps): ReactElement<any> {
  const getSubPanelContent = (): ReactElement<any> => {
    switch (props.subPanel) {
      case TranscriptContextualMenuSubPanel.SENTENCE_TEXT_COLOR:
        return <TranscriptSentenceTextColorPanel />;
      case TranscriptContextualMenuSubPanel.TRANSCRIPT_BACKGROUND_COLOR:
        return <TranscriptBackgroundColorPanel />;
      case TranscriptContextualMenuSubPanel.ACTIVE_WORD_TEXT_COLOR:
        return <TranscriptActiveWordTextColorPanel />;
      case TranscriptContextualMenuSubPanel.SENTENCE_TEXT_OUTLINE_COLOR:
        return <TranscriptSentenceOutlineColorPanel />;
      case TranscriptContextualMenuSubPanel.ACTIVE_WORD_TEXT_OUTLINE_COLOR:
        return <TranscriptActiveWordOutlineColorPanel />;
      case TranscriptContextualMenuSubPanel.TRANSCRIPT_SHADOW_COLOR:
        return <TranscriptShadowPanel />;
      case TranscriptContextualMenuSubPanel.FONT:
        return (
          <TranscriptItemFontSelector
            onBack={() => {
              props.onBack();
            }}
          />
        );
      default:
        throw new Error(`Unhandled sub-panel ${props.subPanel} for transcript customization`);
    }
  };

  return getSubPanelContent();
}
